import { IProject, ProjectStatusType } from 'app/services/responseTypes';
import moment from 'moment';

function isEditableDate(date: string) {
  if (date === null) return true;
  return moment().diff(date, 'days') < 3;
}

export function isEditable(project: IProject) {
  return (
    isEditableDate(project.started_at) &&
    (['pending_pricing', 'draft'] as ProjectStatusType[]).includes(
      project.status,
    )
  );
}
